<!-- <p>modal-reserva works!</p> -->

<div id="reserva" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="recuperarLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" style="margin: auto;">
      <div class="modal-content reserva-bg">
        <div class="modal-header mt-5 border-0">
          <h3 class="modal-title text-primary text-center m-auto" id="recuperarLabel">Confirmación del Viaje</h3>
          <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
          <i (click)="closeModal()" class="bi-x modal-close" aria-label="Close"></i>
        </div>
        <div class="modal-body">
          <div class="row ">
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
              <div class="row" *ngIf="data">
                <div class="col-12 col-lg-12 mb-4">
                  <h5>Destino</h5>
                  <h3 class="text-secondary">{{data.destino}}</h3>
                </div>
                <div class="col-12 col-lg-6">
                  <h5>Cant. de Pasajeros</h5>
                  <h3 *ngIf="data.pasajeros.adultos!=0" class="text-secondary">{{data.pasajeros.adultos}} adultos</h3>
                  <h3 *ngIf="data.pasajeros.menores!=0" class="text-secondary">{{data.pasajeros.menores}} niños</h3>
                  <h3 *ngIf="data.pasajeros.bebes!=0" class="text-secondary">{{data.pasajeros.bebes}} bebés</h3>
                  <a style="cursor: pointer;"  (click)="goPassengers()" class="text-dark" style="cursor: pointer;">Ver datos</a>
                </div>
                <div class="col-12 col-lg-6 mt-4">
                  <h5>Butacas</h5>
                  <h3 class="text-secondary">{{data.asientos}}</h3>
                  <a style="cursor: pointer;"  (click)="goReservation()" class="text-dark" style="cursor: pointer;">Ver reserva</a>
                </div>
                <div class="col-12 col-lg-12 mt-4">
                  <h5>Hotel {{data.hotel}}</h5>
                  <h3 class="text-secondary">{{cadena}}</h3>
                  <a style="cursor: pointer;"  (click)="goReservation()" class="text-dark" style="cursor: pointer;">Ver reserva</a>
                </div>
              </div>
              <p class="text-secondary text-center mt-5">
                <a style="cursor: pointer;"  (click)="openModalReservaConfirmada()" class="btn btn-lg btn-primary btn-reservar rounded-pill"  >Reservar</a>
              </p>
            </div>
            <div class="col-lg-1"></div>
          </div>
        </div>
        <div class="modal-footer mb-5 border-0">
        </div>
      </div>
    </div>
  </div>

